import React from 'react'
import { FiDownload } from "react-icons/fi";
import { FaArrowRight } from "react-icons/fa6";
import { Link } from 'react-router-dom';

const Imgbanner = () => {
    return (
        <section className='md:mt-24'>
            <div
                className="relative my-5 h-[300px] bg-cover bg-center transition-all duration-700"
                style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL}/assets/slider/lmp-slider-1.jpg)`
                }}
            >
                {/* Bottom-right subtle overlay */}
                <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-black/80"></div>


                <div className="absolute inset-0 bg-black/60"></div>
                <div className="relative z-10 p-5">
                    <div className='w-full h-full mt-5'>
                        <h1 className="text-white md:text-4xl text-2xl font-semibold shadow-sm pt-5">
                            Lean Manufacturing Practices
                        </h1>
                        <p className="text-white pt-5 shadow-sm md:text-sm text-xs">
                            Nurturing the next generation of change leaders to create
                        </p>
                        <p className="text-white md:text-sm text-xs shadow-sm">
                            a win-win culture and strengthen the industry-academia ecosystem, benefiting both Indian and Japanese businesses.
                        </p>
                        <Link to="pdf/lmp-brochure-26.pdf" target="_blank" rel="noopener noreferrer">
                            <div className=" w-full pt-5 mt-5 place-items-center">
                                <div className="flex gap-3 py-2 font-bold px-5 items-center bg-white  w-fit rounded-md text-xs">
                                    <FiDownload className='text-green-500 font-semibold text-sm' />
                                    Download Brochure
                                    <FaArrowRight />
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Imgbanner
